import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/integrations/connections/$id/mappings')({});
